import { PaymentChannel } from '@/types'
import '../../pages/parameters/styles/TabStyles.css'

interface PaymentChannelListProps {
  channels: PaymentChannel[]
  onToggle: (id: string, enabled: boolean) => Promise<void>
  onEdit: (channel: PaymentChannel) => void
  onMoveUp: (id: string) => Promise<void>
  onMoveDown: (id: string) => Promise<void>
  loading: boolean
}

export default function PaymentChannelList({
  channels,
  onToggle,
  onEdit,
  onMoveUp,
  onMoveDown,
  loading
}: PaymentChannelListProps) {
  if (channels.length === 0) {
    return (
      <div className="empty-state">
        <p>暂无支付通道</p>
      </div>
    )
  }

  return (
    <div className="table-container">
      <table className="data-table">
        <thead>
          <tr>
            <th>排序</th>
            <th>图标</th>
            <th>通道代码</th>
            <th>通道名称</th>
            <th>状态</th>
            <th>最小金额</th>
            <th>最大金额</th>
            <th>手续费率</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          {channels.map((channel, index) => (
            <tr key={channel.id}>
              <td>
                <div className="sort-buttons">
                  <button
                    className="btn-icon"
                    onClick={() => onMoveUp(channel.id)}
                    disabled={loading || index === 0}
                    title="上移"
                  >
                    ↑
                  </button>
                  <span>{channel.sort_order}</span>
                  <button
                    className="btn-icon"
                    onClick={() => onMoveDown(channel.id)}
                    disabled={loading || index === channels.length - 1}
                    title="下移"
                  >
                    ↓
                  </button>
                </div>
              </td>
              <td className="icon-cell">{channel.channel_icon}</td>
              <td>{channel.channel_code}</td>
              <td>{channel.channel_name}</td>
              <td>
                <button
                  className={`btn-toggle ${channel.is_enabled ? 'enabled' : 'disabled'}`}
                  onClick={() => onToggle(channel.id, !channel.is_enabled)}
                  disabled={loading}
                >
                  {channel.is_enabled ? '已启用' : '已禁用'}
                </button>
              </td>
              <td>¥{channel.config.min_amount}</td>
              <td>¥{channel.config.max_amount}</td>
              <td>{(channel.config.fee_rate * 100).toFixed(2)}%</td>
              <td className="action-cell">
                <button
                  className="btn-small btn-edit"
                  onClick={() => onEdit(channel)}
                  disabled={loading}
                >
                  编辑
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
